import { KeyboardTypeOptions, Pressable, TextInput, View } from "react-native";
import { Controller } from "react-hook-form";

import CheckBox from '@react-native-community/checkbox';
import { PlaceText } from "../components/PlaceText";

import { Dropdown } from 'react-native-element-dropdown';
import { PlaceColors } from "./PlaceColors";
import { DefaultShadow } from "./DefaultShadows";
import Icon from "react-native-vector-icons/Ionicons";
import { useState } from "react";


export enum FindifyInputRendererType {
    Text = 1,
    Paragrath = 2,
    CheckBox = 3,
    Dropdown = 4
}

type textContentTypeValues = 'none'
    | 'URL'
    | 'addressCity'
    | 'addressCityAndState'
    | 'addressState'
    | 'countryName'
    | 'creditCardNumber'
    | 'emailAddress'
    | 'familyName'
    | 'fullStreetAddress'
    | 'givenName'
    | 'jobTitle'
    | 'location'
    | 'middleName'
    | 'name'
    | 'namePrefix'
    | 'nameSuffix'
    | 'nickname'
    | 'organizationName'
    | 'postalCode'
    | 'streetAddressLine1'
    | 'streetAddressLine2'
    | 'sublocality'
    | 'telephoneNumber'
    | 'username'
    | 'password'
    | 'newPassword'
    | 'oneTimeCode';

export type FindifyInputBlockProps = {
    fieldKey: string;
    type: FindifyInputRendererType,
    required?: boolean,
    label?: string,
    placeholder?: string;
    textKeyboardType?: KeyboardTypeOptions | undefined,
    textContentType?: textContentTypeValues | undefined,
    dropdownData?: { label: string, value: any }[],
    dropdownSearch?: boolean,
    validate?: any,
}

export type FindifyInputRendererProps = {
    findifyDataContext: any;
    t: any;
    form: any;
    fieldData: FindifyInputBlockProps,
    style: any,
}
export const FindifyInputRenderer = ({
    t,
    findifyDataContext,
    form,
    fieldData: {
        fieldKey,
        type,
        required,
        label,
        textKeyboardType,
        textContentType,
        dropdownData,
        dropdownSearch,
        validate,
        placeholder,
    },
    style
}: FindifyInputRendererProps) => {

    /* DO NOT DELETE */
    const {
        handleSubmit,
        control,
        reset,
        getValues,
        setValue,
        formState: { errors },
    } = form;
    /* DO NOT DELETE */
    const [hidePass, setHidePass] = useState(textContentType === 'password');

    return <View
        style={style}
    >
        {/* QUESTION */}
        {![FindifyInputRendererType.CheckBox].includes(type) && <PlaceText style={{ marginVertical: 5, color: 'grey' }}>{label}</PlaceText>}
        <View>
            <Controller
                key={fieldKey}
                name={fieldKey}
                control={control}
                rules={{
                    required,
                    validate,
                }}
                render={({ field }) => {
                    switch (type) {
                        case FindifyInputRendererType.Text:
                            return <View
                                style={[{
                                    borderWidth: 1,
                                    borderRadius: 6,
                                    borderColor: PlaceColors(findifyDataContext).text.get(),
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                }, DefaultShadow]}
                            >
                                <TextInput
                                    secureTextEntry={hidePass}
                                    textContentType={textContentType}
                                    placeholder={label}
                                    keyboardType={textKeyboardType}
                                    style={[{
                                        flex: 1,
                                        padding: 5,
                                        borderRadius: 6,
                                        borderColor: PlaceColors(findifyDataContext).text.get(),
                                        color: PlaceColors(findifyDataContext).text.get(),
                                        backgroundColor: PlaceColors(findifyDataContext).background.get()
                                    }, DefaultShadow]}
                                    {...field}
                                    onChangeText={field.onChange}
                                />
                                {textContentType === 'password' &&
                                    <Icon
                                        style={{
                                            color: PlaceColors(findifyDataContext).text.get(),
                                            padding: 3
                                        }}
                                        name="eye-outline"
                                        onPress={() => setHidePass(!hidePass)}
                                    />
                                }
                            </View>
                        case FindifyInputRendererType.Dropdown:
                            const { ref, ...ddfield } = field;
                            return <Dropdown
                                {...ddfield}
                                style={[{
                                    borderWidth: 1,
                                    // padding: 5,
                                    paddingHorizontal: 5,
                                    height: 29,
                                    // height: 'auto',
                                    borderRadius: 6,
                                    borderColor: PlaceColors(findifyDataContext).text.get(),
                                    color: PlaceColors(findifyDataContext).text.get(),
                                    backgroundColor: PlaceColors(findifyDataContext).background.get()
                                }, DefaultShadow]}

                                // placeholder={fieldData.placeholder}
                                itemTextStyle={{ color: PlaceColors(findifyDataContext).text.get() }}
                                inputSearchStyle={{ color: PlaceColors(findifyDataContext).text.get() }}
                                placeholderStyle={{ color: PlaceColors(findifyDataContext).text.get() }}
                                selectedTextStyle={{ backgroundColor: PlaceColors(findifyDataContext).background.get(), color: PlaceColors(findifyDataContext).text.get() }}
                                itemContainerStyle={{ backgroundColor: PlaceColors(findifyDataContext).background.get() }}
                                data={dropdownData ?? []}
                                search={dropdownSearch ?? true}
                                maxHeight={300}
                                labelField="label"
                                valueField="value"
                                onChange={item => {
                                    field.onChange(item.value);
                                }}
                            />;
                        case FindifyInputRendererType.CheckBox:
                            return <View
                                style={{
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    gap: 4,
                                    marginTop: 10,
                                }}
                            >
                                <CheckBox
                                    // {...field}
                                    id={fieldKey}
                                    key={fieldKey}
                                    value={field.value}
                                    boxType="square"
                                    style={DefaultShadow}
                                    onValueChange={(val) => {
                                        field.onChange(val);
                                    }}
                                    tintColor={PlaceColors(findifyDataContext).background.get()}
                                />
                                <PlaceText>{label}</PlaceText>
                            </View>;
                        default:
                            return <PlaceText id={fieldKey}> TODO </PlaceText>;
                    }
                }}
            />
        </View>
        {makeErrorLabel(errors, fieldKey, t)}
    </View>;
}



const makeErrorLabel = (errors: any, fieldKey: string, t: any) => {
    const keySteps = fieldKey.split('.');
    const errorType = keySteps.length === 1 ? errors[keySteps[0]]?.type : (keySteps.length === 2 && errors[keySteps[0]]) ? errors[keySteps[0]][keySteps[1]]?.type : null;
    let errorMsg: string | null = null;
    switch (errorType) {
        // IGNORE NOTHINGS...
        case undefined:
        case null:
            break;
        case 'required':
            errorMsg = t('base.form.errors.is_required');
            break;
        case 'minLenght':
            errorMsg = t('base.form.errors.too_short');
            break;
        case 'maxLength':
            errorMsg = t('base.form.errors.too_long');
            break;
        case 'invalidEmail':
            errorMsg = t('base.form.errors.invalid_email');
            break;
        case 'sameAsEmail':
            errorMsg = t('base.form.errors.same_as_email');
            break;
        case 'sameAsPassword':
            errorMsg = t('base.form.errors.same_as_password');
            break;
        default:
            console.log('failing here', errorType, fieldKey)
            break;
    }

    if (errorMsg) {
        return <PlaceText
            style={{
                color: 'red',
                fontSize: 12,
                marginTop: 2,
            }}>
            {errorMsg}
        </PlaceText>
    }

    return <></>
} 